import { createRouter, createWebHistory } from "vue-router";
import store from "../store/index.js";

import Landing from "@/views/Landing";

import ProfileLayout from "@/layout/OrgProfile";

import Catalog from "@/views/Catalog";
import CatalogCourse from "@/views/Catalog/Course";

import adminRouter from "./modules/admin";
import authRouter from "./modules/auth.js";
import betaRouter from "./modules/beta";
import contentRouter from "./modules/content.js";
import organizationRouter from "./modules/organization";
import registrationRouter from "./modules/registration.js";

const routes = [
  {
    path: "/",
    component: Landing,
  },
  {
    path: "/catalog",
    component: ProfileLayout,
    children: [
      {
        name: "CatalogGeneral",
        path: "",
        component: Catalog,
      },
    ],
  },
  {
    path: "/catalog/course",
    component: CatalogCourse
  },
  authRouter,
  adminRouter,
  betaRouter,
  contentRouter,
  organizationRouter,
  registrationRouter,
  { path: '/:pathMatch(.*)*', redirect: '/' } // Редирект на главную страницу, если 404
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Если есть сохранённая позиция (например, при нажатии "Назад/Вперёд" в браузере)
    if (savedPosition) {
      return savedPosition;
    } else {
      // Всегда поднимаем в начало страницы
      return { top: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  const user = store?.state?.auth?.user;
  const role = user?.role?.name;
  const hasParentCompany = user?.parent_company?.length > 0;
  const hasUserPinTask = user?.UserPinTask?.length > 0;

  const isAdmin = () => role === "admin";
  const handleLogout = () => {
    localStorage.removeItem("vuex");
    localStorage.removeItem("token");
    next("/");
  };

  // Обработка маршрута, требующего пользователя
  if (to.matched.some((record) => record.meta.user)) {
    // Выход, если нет роли
    if (!role) {
      return handleLogout();
    }

    // Редирект для админа
    if (isAdmin()) {
      return next("/admin/checkTask");
    }

    // Редирект на профиль организации при наличии parent_company
    if (hasParentCompany) {
      return next("/org/profile");
    }

    // Продолжаем, если есть задачи
    // if (hasUserPinTask) {
    //   return next();
    // }

    // if (
    //   [
    //     "ContentProjectsList",
    //     "ContentProjectTasks",
    //     "CGChatPage",
    //     "CGResultPage",
    //   ].includes(to.name)
    // ) {
    //   return next();
    // }

    // return next("/registration/user-info");
    return next();
  }

  // Если маршрут требует администратора
  if (to.matched.some((record) => record.meta.admin)) {
    if (!role) {
      return handleLogout();
    }

    if (isAdmin()) {
      return next();
    }

    return next("/");
  }

  // Если маршрут требует аккаунта организации
  if (to.matched.some((record) => record.meta.user_org)) {
    if (!role) {
      return handleLogout();
    }

    if (hasParentCompany) {
      return next();
    }

    return next("/");
  }

  // Если маршрут не требует специальных проверок
  next();
});

export default router;
